import { EActionTypes } from './types';

export type TSetReset = () => {
    type: EActionTypes.RESET;
};

export const setReset: TSetReset = () => ({
    type: EActionTypes.RESET,
});
